<template>
    <div class="container-overall-progress">
        <b-card>
            <p class="title">Overall progress</p>
            <div>
                <b-progress class="mt-2" :max="max" show-value>
                    <b-progress-bar :value="value"></b-progress-bar>
                </b-progress>
                <div class="sub-title">
                    <p>
                        <span class="progress-value">{{ merchantStatus.total_done }}/{{ merchantStatus.total_overall
                        }}</span> task completed
                    </p>
                    <p class="percent">{{ merchantStatus.total_progress }}<span
                            v-if="merchantStatus.total_progress === '0'">%</span></p>
                </div>

            </div>
            <div class="center-btn">
                <b-button @click="startSellingButton" class="btn" :class="{ 'start-selling': startSelling }"
                    :disabled="!startSelling">Launch Your Store</b-button>
            </div>
        </b-card>
        <div v-if="startSellingModal">
            <LiveSellingModal />
        </div>
    </div>
</template>
<script>
import { mapState, mapActions, mapGetters } from "vuex";
import LiveSellingModal from '@/components/onboarding/LiveSellingModal'
export default {
    components: {
        LiveSellingModal
    },
    data() {
        return {
            value: 16.7,
            max: 100,
            test: true,
            initialize: false
        };
    },
    computed: {
        ...mapState("onboarding", {
            merchantStatus: state => state.merchantStatus,
            startSelling: state => state.startSelling,
            startSellingModal: state => state.startSellingModal
        }),

    },
    methods: {
        startSellingButton() {
            this.$store.commit('onboarding/setStartSellingModal', true)

        },
    },

    watch: {
        "merchantStatus.total_progress": {
            handler(newValue) {
                const floatValue = typeof newValue === "string" ? parseFloat(newValue) : newValue;

                this.value = floatValue;
            },
            immediate: true,
        },
        merchantStatus: {
            handler(newMerchantStatus, oldMerchantStatus) {
                const isStep1Completed = newMerchantStatus.progress[0].step_status === "Completed";
                const isStep2Completed = newMerchantStatus.progress[1].step_status === "Completed";

                if (isStep1Completed && isStep2Completed) {
                    this.$store.commit('onboarding/setStartSelling', true);
                }
            },
            deep: true,
        },
    },

};
</script>
<style lang="scss">
.container-overall-progress {
    .card {
        border-radius: 10px;
    }
}
</style>
<style lang="scss" scoped>
.container-overall-progress {
    border-radius: 10px;
    min-width: 400px;
    min-height: 300px;
    width: 100%;
    height: 100%;
    z-index: 999;

    @media(max-width:1200px) {
        min-width: 300px;
    }

    @media(max-width:1100px) {
        min-width: 250px;
    }

    @media (max-width: 991px) {
        min-height: 0px;
        margin-bottom: 50px;
        min-width: 0px;
    }

    .title {
        font-family: MainFontRegular, sans-serif;
        font-size: 18px;
        font-style: normal;
        line-height: normal;
    }

    .sub-title {
        display: flex;
        align-items: center;
        justify-content: space-between;
        color: var(--6-neutrals-grey-600, #68737d);
        font-family: MainFontRegular, sans-serif;
        font-size: 12px;
        margin-top: 5px;
        color: #2F3941;

        .progress-value {
            font-family: MainFontBold, sans-serif;
            font-weight: normal;
        }
    }

    .center-btn {
        display: flex;
        justify-content: center;

        .btn {
            color: #87929D;
            width: 100%;
            font-family: MainFontBold, sans-serif;
            font-weight: normal;
            border-radius: 8px;
            background-color: #E9EBED;
            font-size: 16px;
            cursor: not-allowed;
        }

        .start-selling {
            border: none;
            border-radius: 8px;
            background: #53B6B2;
            cursor: pointer;
            color: #FFF;
            font-family: MainFontRegular, sans-serif;

        }
    }
}

.progress {
    border-radius: 20px;

    .progress-bar {
        color: #118bee;
        border-radius: 20px;
        background-color: #118bee;
    }
}
</style>
